import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=7fa3c701&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=ts&"
export * from "./Column.vue?vue&type=script&lang=ts&"
import style0 from "./Column.vue?vue&type=style&index=0&id=7fa3c701&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3c701",
  null
  
)

export default component.exports